import { defineComponent as y, useSlots as C, openBlock as o, createElementBlock as d, normalizeClass as u, createElementVNode as h, mergeProps as B, unref as k, toDisplayString as f, createCommentVNode as r, renderSlot as L } from "vue";
import { _ as $ } from "../_plugin-vue_export-helper-CHgC5LLL.js";
import '../Checkbox.css';const w = ["id", "aria-checked", "aria-labelledby", "checked", "value", "disabled"], P = ["for"], S = {
  key: 0,
  class: "text-xs text-app-gray-500 dark:text-app-gray-400"
}, E = ["for"], N = /* @__PURE__ */ y({
  __name: "Checkbox",
  props: {
    label: { default: "" },
    description: { default: "" },
    value: { default: "" },
    id: { default: "" },
    checked: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    rounded: { type: Boolean },
    labelPlacement: { default: "right" },
    classes: { default: () => ({}) }
  },
  emits: ["onChange", "update:checked"],
  setup(V, { emit: m }) {
    const t = C(), i = m, g = (e) => {
      var a, l;
      const c = (a = e == null ? void 0 : e.target) == null ? void 0 : a.checked, s = (l = e == null ? void 0 : e.target) == null ? void 0 : l.value;
      i("onChange", c, s, e), i("update:checked", c);
    };
    return (e, c) => {
      var s, a, l, n, b, p;
      return o(), d("div", {
        class: u(["flex items-center w-fit gap-2", `checkbox-label-${e.labelPlacement}`, e.$attrs.class, (s = e.classes) == null ? void 0 : s.container])
      }, [
        h("input", B({
          id: e.id,
          "aria-checked": e.checked,
          "aria-labelledby": e.label || "Checkbox Label",
          checked: e.checked,
          type: "checkbox",
          value: e.value,
          class: ["checkbox-input", { "cursor-pointer": !e.disabled, "cursor-not-allowed hover:!ring-0": e.disabled }, (a = e.classes) == null ? void 0 : a.input],
          disabled: e.disabled
        }, { ...e.$attrs, class: "", style: {} }, { onChange: g }), null, 16, w),
        e.label && !((l = k(t)) != null && l.checkboxLabel) ? (o(), d("label", {
          key: 0,
          for: e.id,
          class: u(["checkbox-label flex flex-col", { "!text-app-gray-400 !cursor-not-allowed": e.disabled }, (n = e.classes) == null ? void 0 : n.label, e.disabled && ((b = e.classes) == null ? void 0 : b.disabled)])
        }, [
          h("span", null, f(e.label), 1),
          e.description ? (o(), d("span", S, f(e.description), 1)) : r("", !0)
        ], 10, P)) : r("", !0),
        (p = k(t)) != null && p.checkboxLabel ? (o(), d("label", {
          key: 1,
          for: e.id
        }, [
          L(e.$slots, "checkboxLabel", {}, void 0, !0)
        ], 8, E)) : r("", !0)
      ], 2);
    };
  }
}), I = /* @__PURE__ */ $(N, [["__scopeId", "data-v-47fb3cde"]]);
export {
  I as default
};
//# sourceMappingURL=Checkbox.esm.js.map
